export default __webpack_public_path__ + "static/Figma-Mock-up-Datapult-3eae49789bac7995a777614330012f53.gif";